var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAuthenticated
    ? _c(
        "div",
        { staticClass: "gfu-navbar-item gfu-navbar-dropdown" },
        [
          _c(
            "toggle-trigger",
            {
              ref: "toggleTrigger",
              staticClass: "gfu-navbar-btn gfu-navbar-dropdown-pointer",
              attrs: {
                tag: "button",
                "active-class": "is-visible",
                tabindex: "0",
                "aria-label": _vm.Resources.Layout.UserBoxTriggerLabel,
                "data-qa": "header-icon:Userbox",
              },
            },
            [_c("user-avatar")],
            1
          ),
          _vm._v(" "),
          _c(
            "toggle-container",
            {
              staticClass: "gfu-navbar-dropdown__content gfu-bt gfu-bt--b2",
              attrs: { "active-class": "is-visible", tabindex: "0" },
            },
            [
              _c("base-balloon", {
                attrs: {
                  "is-pointer-visible": false,
                  position: "right",
                  "data-qa": "user-box",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _vm.isImpersonated
                            ? _c(
                                "div",
                                { staticClass: "gfu-balloon__top-alert" },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.Resources.Layout
                                          .UserBoxImpersonatingLabel
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "gfu-balloon__top-title",
                              attrs: { "data-qa": "user-box:FullName" },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.userContext.user.fullName) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { "data-qa": "user-box:Email" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.userContext.user.email) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isImpersonated
                            ? _c(
                                "div",
                                { staticClass: "_tac _mt-1" },
                                [
                                  _c("revert-impersonation-button", {
                                    attrs: {
                                      "data-qa": "user-box-button:Revert",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            [
                              _vm._l(
                                _vm.groupedLinks,
                                function (value, key, index) {
                                  return [
                                    _c(
                                      "div",
                                      { key: key },
                                      [
                                        index > 0
                                          ? _c("div", {
                                              staticClass:
                                                "_bb-2 _bc--soft _my-2",
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm._l(value, function (link) {
                                          return [
                                            _c(
                                              "div",
                                              { key: link.navigationItemId },
                                              [
                                                _c(
                                                  link.tag,
                                                  {
                                                    tag: "component",
                                                    staticClass:
                                                      "_flex _py-1 _ai-c _gap-2 _fw-b _jc-fs gfu-link-underline",
                                                    attrs: {
                                                      rel: link.rel,
                                                      href: link.to,
                                                      target: link.target,
                                                      "data-qa": `user-box-button:${link.key}`,
                                                    },
                                                    on: { click: link.action },
                                                  },
                                                  [
                                                    _c("base-icon", {
                                                      staticClass:
                                                        "_tc--accent",
                                                      attrs: {
                                                        "icon-namespace":
                                                          link.icon.namespace,
                                                        name: link.icon.name,
                                                        "is-fixed-width": true,
                                                        size: "lg",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "gfu-link-underline__content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(link.label) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    link.isTypeExternal
                                                      ? _c("base-icon", {
                                                          staticClass:
                                                            "_tc--accent _ml-a",
                                                          attrs: {
                                                            name: "external-link",
                                                            "is-fixed-width": true,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        }),
                                      ],
                                      2
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3255426844
                ),
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", { staticClass: "_flex" }, [
        _c(
          "div",
          { staticClass: "gfu-navbar-item _screen--none _screen--flex-m" },
          [
            _c(
              "base-link",
              {
                attrs: { url: _vm.loginUrl, "data-qa": "header-button:login" },
              },
              [
                _c("span", { staticClass: "gfu-navbar-btn" }, [
                  _vm._v(_vm._s(_vm.Resources.Layout.HeaderLoginLink)),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "gfu-navbar-item _screen--none _screen--flex-m" },
          [
            _c(
              "base-link",
              {
                attrs: {
                  url: _vm.createAccountUrl,
                  "data-qa": "header-button:signup",
                },
              },
              [
                _c("span", { staticClass: "gfu-navbar-btn" }, [
                  _vm._v(_vm._s(_vm.Resources.Layout.HeaderSignupLink)),
                ]),
              ]
            ),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }